module.exports = __webpack_public_path__ + "459d771c882d84983af84410a2f78e3e.MP3";